import { defineStore } from 'pinia';
import { useHelpers } from '@/composables/useHelpers';
import { fetchBuildingAlerts } from '@/api';
import { Alert_AlertStatus } from '@/generated/msh/resource/v1/alert_pb';

export default defineStore({
  id: 'dashboard',

  state: () => ({
    recenty_views: [],
    services: null,
    offenders: [],
  }),

  getters: {
    offendersBar() {
      const labels = [];
      const datasets = [
        {
          label: 'Falls',
          backgroundColor: '#59D3EE',
          data: [],
          barThickness: 20,
        },
        {
          label: 'Roaming',
          backgroundColor: '#7A81C2',
          data: [],
          barThickness: 20,
        },
      ];
      const { getVMInstance } = useHelpers();
      const { $t } = getVMInstance();
      for (const offender of this.offenders) {
        labels.push($t('apartment_short') + ' ' + offender.apartment);
        datasets[0].data.push(offender.falls);
        datasets[1].data.push(offender.roaming);
      }

      return { labels, datasets };
    },
  },

  actions: {
    async getItems(parentId) {
      const params = {
        parentId,
        filter: { status: Alert_AlertStatus.WAITING_RESPONSE },
      };
      const { alerts } = await fetchBuildingAlerts(params);
      this.alerts = alerts;

      return { alerts };
    },
  },
});
